export default __webpack_public_path__ + "static/media/Step2.aef4707f.svg";